/* v3.0.6 - Quick view: fotograf uzerinde sag/sol ok navigasyonu.
   ---------------------------------------------------------------------------
   Tema, quick view'da kucuk gorselleri (thumb) `quick-add-hidden` ile gizler;
   biz masaustunde thumb yerine fotografin uzerinde ok gosteriyoruz. Oklar
   YENI bir slider kurmaz - temanin KENDI thumb butonlarini tiklar; boylece
   media-gallery.setActiveMedia zinciri aynen calisir (tek dogruluk kaynagi).

   Ayrica aktif gorselin genisligini `--qv-media-w` degiskenine yazar; CSS
   sarmalayiciyi ve thumb seridini bu olcuye esitler (kullanici istegi:
   "thumbs ile gorsel esitlensin"). JS calismazsa CSS %100 + max-width ile
   guvenli sekilde calismaya devam eder. */
(function () {
  'use strict';

  function thumbsOf(modal) {
    return Array.prototype.slice.call(modal.querySelectorAll('.thumbnail-list__item button.thumbnail'));
  }

  function activeIndex(list) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].getAttribute('aria-current') === 'true') return i;
    }
    return 0;
  }

  /* "48vh" / "460px" / "100%" gibi bir CSS degerini px'e cevirir. */
  function toPx(raw, base) {
    raw = (raw || '').trim();
    var n = parseFloat(raw);
    if (!isFinite(n)) return 0;
    if (raw.indexOf('vh') > -1) return (window.innerHeight * n) / 100;
    if (raw.indexOf('vw') > -1) return (window.innerWidth * n) / 100;
    if (raw.indexOf('rem') > -1) return n * (parseFloat(getComputedStyle(document.documentElement).fontSize) || 10);
    if (raw.indexOf('%') > -1) return (base || 0) * n / 100;
    return n;
  }

  /* Sarmalayiciyi aktif gorselin olcusune esitler.
     Yukseklik siniri dogrudan uygulanamaz (en-boy kutusu `padding-top: %` ile
     kuruluyor, % genislige baglidir) - bu yuzden hedef YUKSEKLIGI genislige
     cevirip sarmalayiciya yaziyoruz. */
  /* Quick view'a enjekte edilen buyuk gorseller `loading=lazy` geliyor ve
     DOM'a `display:none` iken girdikleri icin tarayici tembel yukleme
     kararini bir daha gozden gecirmiyor: ok/thumb ile aktif yapilan gorsel
     BOS kaliyordu. `loading` niteligini eager'a cevirmek bekleyen yuklemeyi
     hemen baslatir (canli olarak dogrulandi). */
  function ensureLoaded(modal) {
    var img = modal.querySelector('.product__media-item.is-active img');
    if (img && !img.complete && img.getAttribute('loading') === 'lazy') img.loading = 'eager';
  }

  /* Kucuk gorseller masaustunde `display:none` oldugu icin hic yuklenmiyor;
     pencere tablet genisligine kuculdugunde BOS kareler olarak beliriyordu.
     Hepsi minik (~70px) - modal acilirken eager'a cevirmek en ucuz cozum. */
  function eagerThumbs(modal) {
    var imgs = modal.querySelectorAll('.thumbnail-list__item img[loading="lazy"]');
    Array.prototype.forEach.call(imgs, function (img) { if (!img.complete) img.loading = 'eager'; });
  }

  function syncWidth(modal) {
    var capH = toPx(getComputedStyle(modal).getPropertyValue('--qv-max-h'), 0);
    var wraps = modal.querySelectorAll('.product__media-wrapper');
    Array.prototype.forEach.call(wraps, function (wrap) {
      var med = wrap.querySelector('.product__media-item.is-active .product__media') || wrap.querySelector('.product__media');
      if (!med) return;
      wrap.style.removeProperty('--qv-media-w');
      var parent = wrap.parentElement;
      var avail = 0;
      if (parent) {
        var pcs = getComputedStyle(parent);
        avail = parent.clientWidth - (parseFloat(pcs.paddingLeft) || 0) - (parseFloat(pcs.paddingRight) || 0);
      }
      var capW = toPx(getComputedStyle(wrap).maxWidth, avail);
      if (!capW) capW = avail;
      if (avail > 0) capW = Math.min(capW, avail);
      var ar = parseFloat(getComputedStyle(med).getPropertyValue('--media-aspect-ratio'));
      if (!isFinite(ar) || ar <= 0) {
        var r = med.getBoundingClientRect();
        ar = r.height > 0 ? (r.width / r.height) : 0;
        if (!isFinite(ar) || ar <= 0) return;
      }
      var w = capH > 0 ? Math.min(capW, capH * ar) : capW;
      if (w > 0) wrap.style.setProperty('--qv-media-w', Math.round(w) + 'px');
    });
  }

  function go(modal, step) {
    var list = thumbsOf(modal);
    if (list.length < 2) return;
    var next = (activeIndex(list) + step + list.length) % list.length;
    list[next].click();
    window.setTimeout(function () { ensureLoaded(modal); syncWidth(modal); }, 60);
  }

  function arrowSvg(dir) {
    var d = dir === 'prev' ? 'M12.5 3.5 6 10l6.5 6.5' : 'M7.5 3.5 14 10l-6.5 6.5';
    return '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">' +
      '<path d="' + d + '" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="square"/></svg>';
  }

  function scrollCueSvg() {
    return '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">' +
      '<path d="M4 7.5 10 13.5l6-6" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="square"/></svg>';
  }

  function updateScrollCue(modal) {
    var content = modal.querySelector('.quick-add-modal__content');
    var cue = modal.querySelector('.quick-view-scroll-cue');
    if (!content || !cue) return;
    var canScroll = content.scrollHeight > content.clientHeight + 8;
    var atEnd = content.scrollTop + content.clientHeight >= content.scrollHeight - 24;
    var visible = canScroll && !atEnd;
    cue.classList.toggle('is-visible', visible);
    cue.setAttribute('aria-hidden', visible ? 'false' : 'true');
    cue.tabIndex = visible ? 0 : -1;
  }

  function mountScrollCue(modal) {
    var content = modal.querySelector('.quick-add-modal__content');
    if (!content) return;
    var cue = modal.querySelector('.quick-view-scroll-cue');
    if (!cue) {
      cue = document.createElement('button');
      cue.type = 'button';
      cue.className = 'quick-view-scroll-cue';
      cue.setAttribute('aria-label', 'Scroll down');
      cue.innerHTML = '<span>Scroll down</span>' + scrollCueSvg();
      cue.addEventListener('click', function () {
        var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        content.scrollBy({
          top: Math.max(240, Math.round(content.clientHeight * 0.68)),
          behavior: reduced ? 'auto' : 'smooth'
        });
      });
      content.addEventListener('scroll', function () {
        window.requestAnimationFrame(function () { updateScrollCue(modal); });
      }, { passive: true });
      modal.appendChild(cue);
    }
    window.requestAnimationFrame(function () { updateScrollCue(modal); });
    window.setTimeout(function () { updateScrollCue(modal); }, 350);
  }

  function mount(modal) {
    var wrap = modal.querySelector('.product__media-wrapper');
    if (!wrap) return false;
    ensureLoaded(modal);
    eagerThumbs(modal);
    syncWidth(modal);
    mountScrollCue(modal);
    /* Modal her acilista quick-add.js tarafindan YENIDEN doldurulur; bu yuzden
       "kuruldu" isareti modal elemanina degil, o anki sarmalayicinin icindeki
       ok butonunun VARLIGINA bakar. (Modal'a sinif koymak, ikinci acilista
       oklarin hic eklenmemesine yol aciyordu - canli olarak yakalandi.) */
    if (wrap.querySelector('.qv-nav')) return true;
    if (thumbsOf(modal).length < 2) return true;
    ['prev', 'next'].forEach(function (dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'qv-nav qv-nav--' + dir;
      b.setAttribute('aria-label', dir === 'prev' ? 'Previous image' : 'Next image');
      b.innerHTML = arrowSvg(dir);
      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        go(modal, dir === 'prev' ? -1 : 1);
      });
      wrap.appendChild(b);
    });
    return true;
  }

  function poll(tries) {
    var modal = document.querySelector('quick-add-modal[open]');
    if (modal && mount(modal)) return;
    if (tries > 0) window.setTimeout(function () { poll(tries - 1); }, 220);
  }

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('.quick-add__submit, .thumbnail-list__item button.thumbnail') : null;
    if (!t) return;
    if (t.classList.contains('thumbnail')) {
      var m = document.querySelector('quick-add-modal[open]');
      if (m) window.setTimeout(function () { ensureLoaded(m); syncWidth(m); }, 60);
      return;
    }
    poll(16);
  }, true);

  /* Theme editor / bfcache / automated preview can restore an already-open
     quick view without replaying the trigger click. Mount in that state too. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { poll(2); }, { once: true });
  } else {
    poll(2);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    var modal = document.querySelector('quick-add-modal[open]');
    if (!modal) return;
    var a = document.activeElement;
    if (a && (a.tagName === 'INPUT' || a.tagName === 'TEXTAREA' || a.tagName === 'SELECT')) return;
    go(modal, e.key === 'ArrowLeft' ? -1 : 1);
  });

  var rAF = null;
  window.addEventListener('resize', function () {
    if (rAF) window.clearTimeout(rAF);
    rAF = window.setTimeout(function () {
      var modal = document.querySelector('quick-add-modal[open]');
      if (modal) {
        syncWidth(modal);
        updateScrollCue(modal);
      }
    }, 120);
  });
})();
